import { AfterViewChecked, Directive, ElementRef, inject } from '@angular/core';

@Directive({
	selector: '[gAutofocus]',
	standalone: false,
})
export class AutofocusDirective implements AfterViewChecked {
	private readonly element: HTMLElement;
	private readonly elementRef = inject(ElementRef);
	private hasFocused: boolean;

	constructor() {
		this.element = this.elementRef.nativeElement;
		this.hasFocused = false;
	}

	ngAfterViewChecked() {
		if (!this.hasFocused) {
			// HACK: Prevent modal from scrolling to bottom of page
			setTimeout(() => this.element.focus(), 100);
			this.hasFocused = true;
		}
	}
}
